import MonthlyAgreement36Page from './MonthlyAgreement36Page';

export default MonthlyAgreement36Page;
